// SPDX-License-Identifier: GPL-3.0-only

export const JSON_VERSIONINFO = "jsonVersionInfo";
